import React from "react";
import CustomPageOverview from "../../Components/CustomPageComponents/CustomPageOverview";

const CustomPage = (props) => {
  return <CustomPageOverview params={props.match.params} />;
};

export default CustomPage;
